import { useContext, useEffect, useState } from 'react'
import { Box, CssBaseline, GlobalStyles, useTheme } from '@mui/material'
import Loader from './components/shared/Loader'
import ErrorPage from './components/shared/ErrorPage'
import ConsentModal from './components/features/Modals/ConsentModal'
import { useKeycloak } from '@react-keycloak/web'
import RoutesComponent from './routers'
import { AuthContext } from './contexts/auth.context'
import { HistoryRouter } from './utils/history'
import { getUserByEmail } from './services/auth.service'
import { useConsentGate } from './hooks/useConsentGate'
import { AppConfigContext } from './contexts/app-config.context'
import { configureAxiosAuth } from './services/axios.service'
import { useTokenActivityRefresher } from './hooks/useTokenRefresher'

import './styles/global.scss'

const App = () => {
  useTokenActivityRefresher()

  const { keycloak, initialized } = useKeycloak()
  const { accept, requiresConsent } = useConsentGate()

  const theme = useTheme()

  const { user: AuthUser, errorMsg, getUser } = useContext(AuthContext)

  useEffect(() => {
    getUser()
  }, [keycloak.tokenParsed])

  useEffect(() => {
    if (initialized && keycloak.authenticated && keycloak.token) {
      configureAxiosAuth(keycloak)
    }
  }, [initialized, keycloak.authenticated, keycloak.token])

  if (errorMsg) {
    return <ErrorPage code={400} message={errorMsg} />
  }

  if (!initialized || (keycloak.authenticated && !AuthUser)) {
    return <Loader />
  }

  return (
    <Box className="App">
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: theme.palette.background,
          },
        }}
      />
      <CssBaseline />
      <HistoryRouter>
        <RoutesComponent />
      </HistoryRouter>
      {requiresConsent && AuthUser && <ConsentModal open={requiresConsent} onAccept={accept} />}
    </Box>
  )
}

export default App
